<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="cantAccessPage === true">
            <div class="container-fluid xyz">
                <div class="page-header-top-container">
                    <div id="cardHeader" class="page-name color-71aa3f">
                        Create Card
                    </div>
                    <button type="submit" class="btn general-button btn-primary" v-on:click.prevent="backshowcard">Back</button>
                </div>
                <div v-if="isDataEditable == true">
                    <div class="admin-page-content">
                        <form id="cardform">
                            <div class="forms-container">
                                <div class="row no-margin">
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 hide">
                                        <div class="alert alert-success" id="alertSuccess">
                                            <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                            <span>Card Added Successfully</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 hide">
                                        <div class="alert alert-danger" id="alertError">
                                            <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                            <span id="errorMsg" class="error"></span>
                                        </div>
                                    </div>


                                    <div class="col-md-6 col-sm-12">
                                      <div class="col-12 forms-block">
                                          <div class="col-3 paddingleft0">
                                              <div class="form-label"><strong>Customer</strong></div>
                                          </div>
                                          <div class="col-9 paddingleft0">
                                              <v-select v-model="customer_id"
                                              @change="changedValue" name="customer_id"
                                                        label="text"
                                                        :filterable="false"
                                                        :options="customerArr"
                                                        @search="onSearch"
                                                        v-validate="'required'"
                                                        placeholder="Select Customer">
                                                  <template slot="no-options">
                                                      Search Customers...
                                                  </template>
                                                  <template slot="option" slot-scope="option">
                                                      <div class="d-center">
                                                          {{ option.text }}
                                                      </div>
                                                  </template>
                                                  <template slot="selected-option" slot-scope="option">
                                                      <div class="selected d-center">
                                                          {{ option.text }}
                                                      </div>
                                                  </template>
                                              </v-select>
                                              <div class="requiredstar">*</div>
                                              <span v-show="errors.has('customer_id')" class="help is-danger" v-if="errors.has('customer_id')"><font color="red">Customer is Required</font></span>
                                          </div>
                                      </div>
                                    </div>

                                    <div class="col-md-6 col-sm-12">
                                        <div class="col-12 forms-block">
                                            <div class="col-3 paddingleft0">
                                                <div class="form-label"><strong>Card#</strong></div>
                                            </div>
                                            <div class="col-9 paddingleft0">
                                                <input type="text" id="card_number" v-validate="'required'" name="card_number" class="form-control"
                                                      placeholder="Last 4 Digits of Card Number" v-model="card_number">
                                                <div class="requiredstar">*</div>
                                                <span v-show="errors.has('card_number')" class="help is-danger" v-if="errors.has('card_number')"><font color="red">Card# is Required</font></span>
                                                <span v-show="cardErr.tooLong" class="help is-danger">
                                                    <font color="red">Card number Must be of {{ allowedLength }} character length</font>
                                                </span>
                                                <span v-show="cardErr.notNumber" class="help is-danger">
                                                    <font color="red">Card number Must be numeric</font>
                                                </span>
                                                
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <!-- <div class="col-md-6 col-sm-12">
                                        <div class="col-12 forms-block">
                                            <div class="col-3 paddingleft0">
                                                <div class="form-label"><strong>Process Date</strong></div>
                                            </div>
                                            <div class="col-9 paddingleft0">
                                                <v-select
                                                    name="process_date"
                                                    v-model="process_date"
                                                    id="direction" label="text"
                                                    :options="daysInMonth"
                                                    placeholder="Days"
                                                ></v-select>
                                            </div>
                                        </div>
                                    </div> -->
                                    <div class="col-md-6 col-sm-12">
                                        <!-- EXP DATE -->
                                        <div class="col-12 forms-block">
                                            <div class="col-3 paddingleft0">
                                                <div class="form-label"><strong>Expiration Date</strong></div>
                                            </div>
                                            <div class="col-9 paddingleft0">
                                                <input type="month" id="expiry_date" v-validate="'required'" name="expiry_date" class="form-control"
                                                      placeholder="Enter Date in MM/DD/YYYY" v-model="expiry_date">
                                                <div class="requiredstar">*</div>
                                                <span v-show="errors.has('expiry_date')" class="help is-danger" v-if="errors.has('expiry_date')"><font color="red">cards Expiration Date is Required</font></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-sm-12">
                                        <div class="col-12 forms-block">
                                            <div class="col-3 paddingleft0">
                                                <div class="form-label"><strong>Notes</strong></div>
                                            </div>
                                            <div class="col-9 paddingleft0">
                                                <textarea rows="10" type="text" id="notes" name="notes" class="form-control no-resize"
                                                        placeholder="Enter notes" v-model="notes"
                                                        ></textarea>
                                            </div>    
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-sm-12">
                                        <div class="col-12 forms-block">
                                            <div class="col-3 paddingleft0">
                                                <div class="form-label"><strong>Email</strong></div>
                                            </div>
                                            <div class="col-9 paddingleft0">
                                                <input type="text" id="email" v-validate="'required'" name="email" class="form-control"
                                                      placeholder="Enter email" v-model="email">
                                                <div class="requiredstar">*</div>
                                                <span v-show="errors.has('email')" class="help is-danger" v-if="errors.has('email')"><font color="red">Email is Required</font></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-sm-12">
                                        <div class="col-12 forms-block">
                                            <div class="col-3 paddingleft0">
                                                <div class="form-label"><strong>Status</strong></div>
                                            </div>
                                            <div class="col-9 paddingleft0">
                                                <v-select
                                                    name="status"
                                                    v-model="status"
                                                    id="status" label="text"
                                                    :options="statusArr"
                                                    :required="true"
                                                    v-validate="'required'"></v-select>
                                                <div class="requiredstar">*</div>
                                                <span v-show="errors.has('status')" class="help is-danger"><font color="red">Status is Required</font></span>
                                            </div> 
                                        </div>   
                                    </div>
                                    <div class="col-md-6 col-sm-12">
                                        <div class="col-12 forms-block">
                                            <div class="col-3 paddingleft0">
                                                <div class="form-label"><strong>Card On File</strong></div>
                                            </div>
                                            <div class="col-9 paddingleft0 customMargin">
                                                <input type="checkbox" id="card_on_file" name="card_on_file" v-model="card_on_file">
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div class="col-md-6 col-sm-12">
                                        <div class="mobile-created-data col-md-6 ml-sm-12 forms-block">
                                            <div class="col-12 paddingleft0">
                                                <div class="form-label"><strong>Created By</strong> : {{ firstName }} {{ lastName }}</div>
                                            </div>
                                        </div>


                                        <div class="mobile-created-data col-md-6 ml-sm-12 forms-block">
                                            <div class="col-12 paddingleft0">
                                                <div class="form-label"><strong>Created at</strong> : {{ created_at }}</div>
                                            </div>
                                        </div>



                                        <div v-if="is_update" class="mobile-created-data col-md-6 ml-sm-12 forms-block">
                                            <div class="col-12 paddingleft0">
                                                <div class="form-label"><strong>Updated By</strong> : {{ u_firstName }} {{ u_lastName }}</div>
                                            </div>
                                        </div>


                                        <div v-if="is_update" class="mobile-created-data col-md-6 ml-sm-12 forms-block">
                                            <div class="col-12 paddingleft0">
                                                <div class="form-label"><strong>Updated at</strong> : {{ updated_at }}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12 ml-3">
                                        <div class="col-12 paddingleft0">
                                            <input id="addcardBtn" type="submit" value="Save" class="btn general-button btn-primary" v-on:click.prevent="AddCard()">
                                            <input id="Cancelcard" type="submit" value="Cancel" class="btn general-button btn-primary" v-on:click.prevent="backshowcard">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div v-if="isDataEditable == false" >
                    <div class="admin-page-content">
                        <div class="col-md-12 error-detail-main forms-container">
                            <div class="error-template">
                                <h1>Oops!</h1>
                                <!--<h2>403</h2>-->
                                <div class="error-details">Sorry You can't Edit This Record...</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="admin-page-content">
                <div class="col-md-12 error-detail-main forms-container">
                    <div class="error-template">
                        <h1>Oops!</h1>
                        <h2>403</h2>
                        <div class="error-details">Sorry!, You don't have permission to access this page.</div>
                    </div>
                </div>
            </div>
        </template>
        <app-footer></app-footer>
    </div>
</template>

<script>
    import index from "../../router";
    import Vue from "vue";
    import EventBus from "../event-bus";
    import FrontFooter from '@/components/partials/FrontFooter';
    import VeeValidate from "vee-validate";
    import SessioMixin from '../../mixins/sessionmixin';
    Vue.use(VeeValidate);
// import moment from 'moment'
    /* Vue FlatPickr */
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    var contex;
    export default {
        name: "AddCard",
        components: {
            'app-footer': FrontFooter,
            flatPickr,
        },
        mixins: [SessioMixin],
        data() {
            return {
                tempReason: '',
                is_update: false,
                created_at: '',
                updated_at: '',
                other_reason: '',
                ptTaxId: '',
                svTaxId: '',
                card_amount:'',
                card_number:'',
                daysInMonth:[],
                selectedDay:'',
                card_on_file:false,
                notes:'',
                expiry_date: "",
                process_date: {text:"1st of the month",value:"1"},
                status: '',
                email:'',
                isShowLoggedinfields: true,
                firstName: "",
                lastName: "",
                u_firstName: "",
                u_lastName: "",
                userName: "",
                permissions: [],
                cantAccessPage: true,
                isLoggedIn: false,
                customerId: 0,
                created_by: "",
                updated_by: "",
                flatpickrConfig: {
                    wrap: true, // set wrap to true only when using 'input-group'
                    altFormat: 'm/Y',
                    altInput: true,
                    dateFormat: 'Y-m',
                    enableTime: false,
                    monthSelectorType: 'static',
                    //locale: Hindi, // locale for this instance only
                },
                status: {value: "active", text: "Active"},
                subject: "",
                notes: "",

                statusArr: [
                    {
                        value: "active",
                        text: "Active"
                    },
                    {
                        value: "expired",
                        text: "Expired"
                    },
                ],

                due_date: "",
                customer_id: "",
                options: "",
                customerArr: [],
                user_id: "",
                userArr: [],
                isDataEditable: true,
                loginID: "",
                cardErrors: {
                    required: false,
                    notNumber: false,
                    tooLarge:false
                },
                cardErr: {
                    tooLong:false
                },
                allowedLength:4
            };
        },
        
        watch: {
            customer_id: function (customer_id) {
                var self = this;

                if(customer_id != null && customer_id != '') {
                }

                if (!self.$route.path.includes('update')) {
                    if (typeof (customer_id) == "undefined" || customer_id == null) {
                        self.user_id = {value: '', text: ''};
                    } else {
                        
                        if (customer_id == '') {
                            self.user_id = {value: '', text: ''};
                        } else {
                            $.ajax({
                                url: process.env.ROOT_API + "/get/customer/user",
                                type: "GET",
                                headers: {
                                    Accept: "application/json",
                                    "Access-Control-Allow-Origin": "*",
                                    Authorization: "Bearer " + localStorage.getItem("api_token"),
                                    "Access-Control-Allow-Headers":
                                            "Origin, Content-Type, Authorization,X-Requested-With",
                                    "Cache-Control": "no-cache"
                                },
                                data: {
                                    customer_id: customer_id.value
                                },
                                dataType: "json",
                                success: function (data) {
                                    if (customer_id.value) {
                                        self.user_id = {value: data[0].value, text: data[0].text};
                                        self.userArr = data;
                                    }
                                },
                                error: function (jqXHR, exception) {
                                    if (jqXHR.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        if (jqXHR.status == 401) {
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            self.$router.push("/login");
                                        }
                                        self.error = jqXHR.responseJSON.message;
                                    }
                                }
                            });
                        }
                    }
                }
            },
            
        },
        beforeMount: function () {
            var app = this;
            contex = this;
            var check = localStorage.getItem("api_token");

            if (check != null) {
                app.isLoggedIn = true;
                app.getPermissions();
            }
        },
        mounted: function () {
            var self = this;

            $(".removeActive").removeClass("active");
            if (self.$route.path.includes('update')) {
                self.is_update = true;
                if (self.$route.params.from != 0) {
                    $("#menucustomers").addClass("active");
                } else {
                    $("#menucard").addClass("active");
                }
            } else {
                self.created_at = self.getCurrentDateTime('');
                if (self.$route.params.from != 0) {
                    $("#menucustomers").addClass("active");
                } else {
                    $("#menucard").addClass("active");
                }

                self.card_reason = {
                  SettingValue: "card Exemption",
                };
            }

            if (localStorage.getItem("menu_small") == "1") {
                self.menuSmall();
            } else {
                self.menuBig();
            }
            if (self.$route.path.includes('update')) {
                if (self.$route.params.id != undefined) {
                    self.showLoader();
                    self.loadcard();
                    $("#addAndContinuecardBtn").hide();
                    $("#addcardBtn").val("Update");
                    $("#cardHeader").text("Edit Card");
                }
            } else {
                if (self.$route.params.id != 0) {
                    self.customerId = self.$route.params.id;
                    self.loadCustomeradd();
                }
            }

            var userObj = localStorage.getItem("user_obj");
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                self.loginID = userJson.id;
                EventBus.$emit(
                        "logged-in",
                        false,
                        userJson["first_name"],
                        userJson["last_name"],
                        userJson["email"]
                        );
            }

            self.daysInMonth = Array.from({ length: 31 }, (_, i) => {
                const day = i + 1;
                const suffix = this.getDaySuffix(day);
                return {
                value: day,
                text: `${day}${suffix} of the month`
                };
            });
        },
        methods: {
            getCurrentDateTime(givenDate) {
              // console.log('givenDate==', givenDate);
              if(givenDate == '') {
                var today = new Date();
              } else {
                var today = new Date(givenDate);
              }


                var dd = today.getDate();
                var mm = today.getMonth()+1;
                var yyyy = today.getFullYear();

                var HH = today.getHours();
                var MM = today.getMinutes();
                var SS = today.getSeconds();

                if(dd<10)
                {
                    dd='0'+dd;
                }

                if(mm<10)
                {
                    mm='0'+mm;
                }

                if(HH<10)
                {
                    HH='0'+HH;
                }

                if(MM<10)
                {
                    MM='0'+MM;
                }

                if(SS<10)
                {
                    SS='0'+SS;
                }

                var date = mm+'-'+dd+'-'+yyyy;
                var time = HH + ":" + MM + ":" + SS;

                today = date + " " + time;
                return today;
            },
            getPermissions: function () {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/user/permission",
                    type: "POST",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        if (data.status == 'success') {
                            self.cantAccessPage = false;
                            self.permissions = data.content;
                            let current_build = window.localStorage.getItem("build_version");
                            let latest_build = data.build;
                            if (current_build != undefined && current_build == '') {
                                localStorage.setItem("build_version", data.build);
                            } else if (current_build != latest_build) {
                                localStorage.setItem("build_version", data.build);
                                location.reload(true);
                            }
                            if (self.permissions.length > 0) {
                                for (var i = 0; i < self.permissions.length; i++) {
                                    if (self.permissions[i].name == 'can_add_credit_card') {
                                        self.cantAccessPage = true;
                                    }
                                }
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.cantAccessPage = false;
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }

                });
            },
            changedValue: function (value) {
                //console.log(value);
            },

            onSearch(search, loading) {
                var self = this;
                if (search.length > 2) {
                    loading(true);
                    self.loadCustomer(loading, search, this);
                }
            },
            onSearchTax(search, loading) {
                var self = this;
                if (search.length >= 1) {
                    loading(true);
                    self.loadTax(loading, search, this);
                }
            },
           
            loadCustomer(loading, search, vm) {
                var self = this;

                $.ajax({
                    url: process.env.ROOT_API + "/get/customers",
                    type: "GET",
                    headers: {
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        "Access-Control-Allow-Headers":
                                "Origin, Content-Type, Authorization,X-Requested-With",
                        "Cache-Control": "no-cache"
                    },
                    data: {
                        search: search
                    },
                    dataType: "json",
                    success: function (data) {
                        loading(false);
                        self.customerArr = data;
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },

            loadCustomeradd() {
                var self = this;

                $.ajax({
                    url: process.env.ROOT_API + "/get/customers",
                    type: "GET",
                    headers: {
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        "Access-Control-Allow-Headers":
                                "Origin, Content-Type, Authorization,X-Requested-With",
                        "Cache-Control": "no-cache"
                    },
                    data: {
                        default: self.customerId
                    },
                    dataType: "json",
                    success: function (data) {
                        self.customer_id = {value: data[0].value, text: data[0].text};
                        self.customerArr = data;
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            backshowcard() {
                var self = this;

                if (self.$route.path.includes('update')) {
                    if (self.$route.params.from != 0) {
                        self.$router.push("/customer/view/" + self.$route.params.from);
                    } else {
                        self.$router.push("/card/list");
                    }
                } else {
                    if (self.$route.params.id != 0) {
                        self.$router.push("/customer/view/" + self.$route.params.id);
                    } else {
                        self.$router.push("/card/list");
                    }
                }
            },
           
            isValidLength(value) {
                // Remove decimal point and check length of numeric part
                const numericValue = String(value).replace('.', '').replace(/,/g, '');
                return numericValue.length == this.allowedLength;
            },
            isNumeric(value) {
                // Check if the value is a number and contains only digits
                const numericPattern = /^\d+$/; // Matches one or more digits
                return numericPattern.test(String(value));
            },
            AddCard(flag) {
                var self = this;
                var cardError = false;
                self.cardErr.tooLong = false;
                self.cardErr.notNumber = false;

                if (!self.isValidLength(self.card_number) && self.card_number != ''){
                    self.cardErr.tooLong = true;
                    cardError = true;
                }
                if (!self.isNumeric(self.card_number) && self.card_number != ''){
                    self.cardErr.notNumber = true;
                    cardError = true;
                }
                
                self.$validator.validate().then(result => {
                    if (result && !cardError) {
                        if (self.$route.path.includes('update')) {
                            if (self.$route.params.id) {
                                $("#addcardBtn").val("Updating ...");
                                $("#addcardBtn").prop("disabled", true);
                                // $("#addAndContinueCaseBtn").prop('disabled',true);
                                $("#Cancelcard").prop("disabled", true);
                            } else {
                                if (flag == "Save and Continue") {
                                    $("#addAndContinuecardBtn").val("Saving ...");
                                    $("#addAndContinuecardBtn").prop("disabled", true);
                                    $("#addcardBtn").prop("disabled", true);
                                    $("#Cancelcard").prop("disabled", true);
                                } else {
                                    $("#addcardBtn").val("Saving ...");
                                    $("#addcardBtn").prop("disabled", true);
                                    $("#addAndContinuecardBtn").prop("disabled", true);
                                    $("#Cancelcard").prop("disabled", true);
                                }
                            }
                        } else {
                            if (flag == "Save and Continue") {
                                $("#addAndContinuecardBtn").val("Saving ...");
                                $("#addAndContinuecardBtn").prop("disabled", true);
                                $("#addcardBtn").prop("disabled", true);
                                $("#Cancelcard").prop("disabled", true);
                            } else {
                                $("#addcardBtn").val("Saving ...");
                                $("#addcardBtn").prop("disabled", true);
                                $("#addAndContinuecardBtn").prop("disabled", true);
                                $("#Cancelcard").prop("disabled", true);
                            }
                        }

                        var fields = $("#cardform").serializeArray();
                        // fields.push({name: "card_amount", value: self.card_amount});
                        fields.push({name: "customer_id", value: self.customer_id.value});
                        fields.push({name: "user_id", value: self.user_id.value});
                        // fields.push({name: "card_number", value: self.card_number });
                        fields.push({name: "status", value: self.status.value});
                        // fields.push({name: "process_date", value: self.process_date.value});
                        // fields.push({name: "expiry_date", value: self.expiry_date });
                        fields.push({name: "email", value: self.email });
                        fields.push({name: "card_on_file", value: self.card_on_file });
                        
                        self.$validator.validateAll();
                        self.$validator.errors.clear();
                        if (self.$route.path.includes('update')) {
                            if (self.$route.params.id) {
                                fields.push({name: "id", value: self.$route.params.id});
                            } else {
                                fields.push({name: "id", value: 0});
                            }
                        } else {
                            fields.push({name: "id", value: 0});
                        }
                        self.showLoader();
                        $.ajax({
                            url: process.env.ROOT_API + "/credit-card/create",
                            type: "POST",
                            data: fields,
                            headers: {
                                Accept: "application/json",
                                "Access-Control-Allow-Origin": "*",
                                Authorization: "Bearer " + localStorage.getItem("api_token"),
                                "Access-Control-Allow-Headers":
                                        "Origin, Content-Type, Authorization,X-Requested-With",
                                "Cache-Control": "no-cache"
                            },
                            dataType: "json",
                            success: function (data) {
                                self.hideLoader();
                                if (self.$route.path.includes('update')) {
                                    if (self.$route.params.id) {
                                        $("#addcardBtn").val("Update");
                                        $("#addcardBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#Cancelcard").prop("disabled", false);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinuecardBtn").val("Save and Continue");
                                            $("#addAndContinuecardBtn").prop("disabled", false);
                                            $("#addcardBtn").prop("disabled", false);
                                            $("#Cancelcard").prop("disabled", false);
                                        } else {
                                            $("#addcardBtn").val("Save");
                                            $("#addcardBtn").prop("disabled", false);
                                            $("#addAndContinuecardBtn").prop("disabled", false);
                                            $("#Cancelcard").prop("disabled", false);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinuecardBtn").val("Save and Continue");
                                        $("#addAndContinuecardBtn").prop("disabled", false);
                                        $("#addcardBtn").prop("disabled", false);
                                        $("#Cancelcard").prop("disabled", false);
                                    } else {
                                        $("#addcardBtn").val("Save");
                                        $("#addcardBtn").prop("disabled", false);
                                        $("#addAndContinuecardBtn").prop("disabled", false);
                                        $("#Cancelcard").prop("disabled", false);
                                    }
                                }
                                if (data.status == "success") {
                                    // self.$router.push('/card/list');

                                    if (flag == "Save and Continue") {
                                        $("html, body").animate({scrollTop: "0px"}, 500);
                                        $(".alert-success").parent().removeClass("hide");
                                        $(".alert-success").parent().addClass("show");
                                        self.card_no= '';
                                        self.notes= '';
                                        self.process_date= '';
                                        self.expiry_date= '';
                                        self.customer_id = '';
                                        self.user_id = '';
                                        self.customerArr = [];
                                        self.userArr = [];
                                        self.email = '';
                                        self.card_on_file = false;
                                        //$("#due_date").val("");
                                        if (self.$route.params.id != 0) {
                                            self.customerId = self.$route.params.id;
                                            self.loadCustomeradd();
                                        }
                                        setTimeout(function () {
                                            $(".alert-success").parent().removeClass("show");
                                            $(".alert-success").parent().addClass("hide");
                                        }, 5000);
                                    } else {
                                        self.backshowcard();
                                    }
                                } else {
                                    // $(".alert-danger").parent().removeClass('hide');
                                    // $(".alert-danger").parent().addClass('show');
                                    if (data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < data.content.length; i++) {
                                            err += data.content[i] + "<br>";
                                        }
                                        $("#errorMsg").html(err);
                                        $(".alert-danger").parent().removeClass("hide");
                                        $(".alert-danger").parent().addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").parent().removeClass("show");
                                            $(".alert-danger").parent().addClass("hide");
                                        }, 5000);
                                    }
                                }
                            },
                            error: function (jqXHR, exception) {
                                self.hideLoader();
                                if (self.$route.path.includes('update')) {
                                    if (self.$route.params.id) {
                                        $("#addcardBtn").val("Update");
                                        $("#addcardBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#Cancelcard").prop("disabled", false);
                                        $("#errorMsg").html(jqXHR.responseJSON.message);
                                        $(".alert-danger").parent().removeClass("hide");
                                        $(".alert-danger").parent().addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").parent().removeClass("show");
                                            $(".alert-danger").parent().addClass("hide");
                                        }, 5000);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinuecardBtn").prop("disabled", false);
                                            $("#addAndContinuecardBtn").val("Save and Continue");
                                            $("#addcardBtn").prop("disabled", false);
                                            $("#Cancelcard").prop("disabled", false);
                                            $("#errorMsg").html(jqXHR.responseJSON.message);
                                            $(".alert-danger").parent().removeClass("hide");
                                            $(".alert-danger").parent().addClass("show");
                                            self.card_no= '';
                                            self.notes= '';
                                            self.process_date= '';
                                            self.expiry_date= '';
                                            self.customer_id = '';
                                            self.user_id = '';
                                            self.customerArr = [];
                                            self.userArr = [];
                                            self.email = '';
                                            self.card_on_file = false;
                                            //$("#due_date").val("");
                                            if (self.$route.params.id != 0) {
                                                self.customerId = self.$route.params.id;
                                                self.loadCustomeradd();
                                            }
                                            setTimeout(function () {
                                                $(".alert-danger").parent().removeClass("show");
                                                $(".alert-danger").parent().addClass("hide");
                                            }, 5000);
                                        } else {
                                            $("#addcardBtn").val("Save");
                                            $("#addcardBtn").prop("disabled", false);
                                            $("#addAndContinuecardBtn").prop("disabled", true);
                                            $("#Cancelcard").prop("disabled", false);
                                            $("#errorMsg").html(jqXHR.responseJSON.message);
                                            $(".alert-danger").parent().removeClass("hide");
                                            $(".alert-danger").parent().addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").parent().removeClass("show");
                                                $(".alert-danger").parent().addClass("hide");
                                            }, 5000);
                                        }

                                        if (jqXHR.status == 0) {
                                            self.errorMsg = "Remote server can not be reachable";
                                        } else {
                                            //redirect to login page if user not authenticated
                                            if (jqXHR.status == 401) {
                                                //clear previous data
                                                localStorage.removeItem("user_obj");
                                                localStorage.removeItem("api_token");
                                                //EventBus.$emit("logged-in", true, "", "");
                                                self.$router.push("/login");
                                            }
                                            $("#errorMsg").html(jqXHR.responseJSON.message);
                                            $(".alert-danger").parent().removeClass("hide");
                                            $(".alert-danger").parent().addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").parent().removeClass("show");
                                                $(".alert-danger").parent().addClass("hide");
                                            }, 5000);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinuecardBtn").prop("disabled", false);
                                        $("#addAndContinuecardBtn").val("Save and Continue");
                                        $("#addcardBtn").prop("disabled", false);
                                        $("#Cancelcard").prop("disabled", false);
                                        $("#errorMsg").html(jqXHR.responseJSON.message);
                                        $(".alert-danger").parent().removeClass("hide");
                                        $(".alert-danger").parent().addClass("show");
                                        self.card_no= '';
                                        self.notes= '';
                                        self.process_date= '';
                                        self.expiry_date= '';
                                        self.customer_id = '';
                                        self.user_id = '';
                                        self.customerArr = [];
                                        self.userArr = [];
                                        self.email = '';
                                        self.card_on_file = false;
                                        if (self.$route.params.id != 0) {
                                            self.customerId = self.$route.params.id;
                                            self.loadCustomeradd();
                                        }
                                        //$("#due_date").val("");
                                        setTimeout(function () {
                                            $(".alert-danger").parent().removeClass("show");
                                            $(".alert-danger").parent().addClass("hide");
                                        }, 5000);
                                    } else {
                                        $("#addcardBtn").val("Save");
                                        $("#addcardBtn").prop("disabled", false);
                                        $("#addAndContinuecardBtn").prop("disabled", true);
                                        $("#Cancelcard").prop("disabled", false);
                                        $("#errorMsg").html(jqXHR.responseJSON.message);
                                        $(".alert-danger").parent().removeClass("hide");
                                        $(".alert-danger").parent().addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").parent().removeClass("show");
                                            $(".alert-danger").parent().addClass("hide");
                                        }, 5000);
                                    }

                                    if (jqXHR.status == 0) {
                                        self.errorMsg = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (jqXHR.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            //EventBus.$emit("logged-in", true, "", "");
                                            self.$router.push("/login");
                                        }
                                        $("#errorMsg").html(jqXHR.responseJSON.message);
                                        $(".alert-danger").parent().removeClass("hide");
                                        $(".alert-danger").parent().addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").parent().removeClass("show");
                                            $(".alert-danger").parent().addClass("hide");
                                        }, 5000);
                                    }
                                }
                            }
                        });
                    }
                });
            },

            loadcard() {
                var self = this;
                self.showLoader();
                $.ajax({
                    url: process.env.ROOT_API + "/credit-card/" + self.$route.params.id,
                    type: "GET",
                    headers: {
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        "Access-Control-Allow-Headers":
                                "Origin, Content-Type, Authorization,X-Requested-With",
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        self.hideLoader();
                        self.created_at = self.getCurrentDateTime(data.content.created_at);;
                        self.updated_at = self.getCurrentDateTime(data.content.updated_at);
                        self.card_number = data.content.card_number;
                        self.notes = data.content.notes;
                        self.expiry_date = data.content.expiry_date;
                        // self.process_date = data.content.process_date;
                        self.customer_id = {
                            value: data.content.cid,
                            text: data.content.first_name + " (" + data.content.cusid + ")"
                        };
                        self.user_id = {
                            value: data.content.uid,
                            text:
                                    data.content.user_firstname +
                                    " " +
                                    data.content.user_lastname/* +
                                        data.content[0].user_email*/
                        };
                        self.status = {
                            value: data.content.status,
                            text: self.formatString(data.content.status)
                        };
                        self.email = data.content.email;
                        self.card_on_file = data.content.card_on_file;
                        // console.log(data.content.updated_user_firstname);
                        self.u_firstName = data.content.updated_user_firstname;
                        self.u_lastName = data.content.updated_user_lastname;

                    },
                    error: function (jqXHR, exception) {
                        self.hideLoader();
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            formatString(data) {
                var self = this;
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
            menuSmall: function () {
                $(".opensidebar").show();
                $(".closesidebar").hide();
                $(".menu").addClass("menusmall");
                $(".sidemenu li a span,.legal").addClass("displaynone");
                $(".sidemenu li a i").addClass("displayicons");
                $(".sidebar").css({width: "70px"});
                $(".content").css({marginLeft: "70px"});
                $("html, body").animate({scrollTop: 0}, 10);
            },
            menuBig: function () {
                $(".opensidebar").hide();
                $(".closesidebar").show();
                $(".menu").removeClass("menusmall");
                $(".sidemenu li a span,.legal").removeClass("displaynone");
                $(".sidemenu li a i").removeClass("displayicons");
                $(".sidebar").css({width: "260px"});
                $(".content").css({marginLeft: "260px"});
                $("html, body").animate({scrollTop: 0}, 10);
            },
        }
    };
    EventBus.$on('logged-in', function (isLogin, fname, lname, email) {
        if (typeof (contex) != "undefined") {
            contex.isShowLoggedinfields = isLogin;
            contex.firstName = fname;
            contex.lastName = lname;
            contex.userName = email;
        }
    });
</script>
<style>
.customMargin{
    margin-top: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/creditCard/AddCard.vue